export default __webpack_public_path__ + "static/media/gallery_00.ca1bb45d.jpg";